var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 257.1 264.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f5f5;}.cls-2{fill:#e6e6e6;}.cls-3{fill:#37474f;}.cls-4{fill:#455a64;}.cls-5{fill:#f7dd6f;}.cls-6{fill:#fdd106;}.cls-13,.cls-7{fill:#263238;}.cls-8{fill:#e0e0e0;}.cls-9{fill:#ebebeb;}.cls-10,.cls-11,.cls-14,.cls-16,.cls-27,.cls-28,.cls-33{fill:#fff;}.cls-11,.cls-13,.cls-14,.cls-16,.cls-27{isolation:isolate;}.cls-11,.cls-12{opacity:0.5;}.cls-13,.cls-18{opacity:0.9;}.cls-14,.cls-15{opacity:0.6;}.cls-16,.cls-17{opacity:0.8;}.cls-19{opacity:0.7;}.cls-20{opacity:0.3;}.cls-21{fill:#c2e576;}.cls-22{fill:#96c93d;}.cls-23{fill:#ffa8a7;}.cls-24{fill:#fafafa;}.cls-25{opacity:0.4;}.cls-26{fill:#f28f8f;}.cls-27{opacity:0.75;}.cls-28,.cls-33{font-size:7.64px;font-family:PTSans-Bold, PT Sans;font-weight:700;}.cls-28{letter-spacing:0.08em;}.cls-29{letter-spacing:0.05em;}.cls-30{letter-spacing:0.04em;}.cls-31,.cls-33{letter-spacing:0.04em;}.cls-32{letter-spacing:0.03em;}.cls-34{letter-spacing:0.05em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-64"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-64-2",
    "data-name": "freepik--floor--inject-64",
    className: "cls-1",
    cx: 128.55,
    cy: 193.48,
    rx: 128.55,
    ry: 71.17
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-64",
    className: "cls-2",
    d: "M266,200.7l-71.66,41.39a2.12,2.12,0,0,1-1.93,0L89.1,182.47a.58.58,0,0,1-.42-.69.59.59,0,0,1,.42-.42L160.76,140a2.12,2.12,0,0,1,1.93,0L266,199.59a.58.58,0,0,1,.42.7A.6.6,0,0,1,266,200.7Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-64-2",
    "data-name": "freepik--shadow--inject-64",
    className: "cls-2",
    cx: 77.74,
    cy: 222.16,
    rx: 43.04,
    ry: 24.85
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-64-3",
    "data-name": "freepik--shadow--inject-64",
    className: "cls-2",
    cx: 130.15,
    cy: 193.35,
    rx: 33.88,
    ry: 19.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-64-4",
    "data-name": "freepik--shadow--inject-64",
    className: "cls-2",
    cx: 205.5,
    cy: 219.57,
    rx: 21.27,
    ry: 12.28
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-64-2",
    "data-name": "freepik--desk--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M195.91,168.14v63.64a1.39,1.39,0,0,1-.64,1.11l-1.36.79a1.46,1.46,0,0,1-1.29,0l-1.36-.79a1.43,1.43,0,0,1-.65-1.11V168.14c0-.4.29-.57.65-.36l1.36.78a1.4,1.4,0,0,0,1.29,0l1.36-.78C195.63,167.57,195.91,167.74,195.91,168.14Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M192.62,233.65l-1.36-.79a1.43,1.43,0,0,1-.65-1.11V168.14c0-.4.29-.57.65-.36l1.36.78a1.41,1.41,0,0,1,.64,1.1v63.63C193.26,233.69,193,233.87,192.62,233.65Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M254.11,134.53v63.6a1.39,1.39,0,0,1-.64,1.11l-1.37.8a1.44,1.44,0,0,1-1.28,0l-1.37-.79a1.43,1.43,0,0,1-.64-1.11V134.53c0-.41.29-.58.64-.38l1.37.8a1.44,1.44,0,0,0,1.28,0l1.37-.8C253.82,134,254.11,134.11,254.11,134.53Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M250.82,200l-1.37-.79a1.43,1.43,0,0,1-.64-1.11V134.53c0-.41.29-.58.64-.38l1.37.8a1.42,1.42,0,0,1,.64,1.11v63.6A.4.4,0,0,1,250.82,200Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.54,122.92v63.63a1.45,1.45,0,0,1-.65,1.12l-1.36.78a1.38,1.38,0,0,1-1.28,0l-1.37-.78a1.41,1.41,0,0,1-.64-1.12V122.92c0-.41.29-.58.64-.37l1.38.79a1.46,1.46,0,0,0,1.29,0l1.36-.79C117.25,122.34,117.54,122.51,117.54,122.92Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.26,188.42l-1.36-.78a1.41,1.41,0,0,1-.64-1.12V122.89c0-.41.28-.57.64-.37l1.36.82a1.39,1.39,0,0,1,.64,1.11v63.6C114.89,188.46,114.6,188.63,114.26,188.42Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M266.76,139.05v-.46a2.58,2.58,0,0,0-1.15-2L163,77.36a2.54,2.54,0,0,0-2.34,0L97.52,113.82a2.54,2.54,0,0,0-1.14,2v.5a2.57,2.57,0,0,0,1.14,2l102.62,59.19a2.61,2.61,0,0,0,2.34,0l63.13-36.49A2.55,2.55,0,0,0,266.76,139.05Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M266.76,139.05v-.46a2.58,2.58,0,0,0-1.15-2L163,77.36a2.54,2.54,0,0,0-2.34,0L97.52,113.82a2.54,2.54,0,0,0-1.14,2v.5a2.57,2.57,0,0,0,1.14,2l102.62,59.19a2.61,2.61,0,0,0,2.34,0l63.13-36.49A2.55,2.55,0,0,0,266.76,139.05Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M201.3,174.66v3.16a2.44,2.44,0,0,0,1.15-.28l63.16-36.46a2.61,2.61,0,0,0,1.15-2v-.47a2.61,2.61,0,0,0-.95-1.87c.42.36.35.86-.22,1.19l-63.13,36.47A2.48,2.48,0,0,1,201.3,174.66Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M201.3,174.66v3.16a2.44,2.44,0,0,0,1.15-.28l63.16-36.46a2.61,2.61,0,0,0,1.15-2v-.47a2.61,2.61,0,0,0-.95-1.87c.42.36.35.86-.22,1.19l-63.13,36.47A2.48,2.48,0,0,1,201.3,174.66Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M265.61,137.91l-63.14,36.47a2.61,2.61,0,0,1-2.34,0L97.51,115.2a.71.71,0,0,1-.45-.91.68.68,0,0,1,.45-.44l63.13-36.49a2.54,2.54,0,0,1,2.34,0l102.63,59.2a.7.7,0,0,1,.45.9A.72.72,0,0,1,265.61,137.91Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M265.61,137.91l-63.14,36.47a2.61,2.61,0,0,1-2.34,0L97.51,115.2a.71.71,0,0,1-.45-.91.68.68,0,0,1,.45-.44l63.13-36.49a2.54,2.54,0,0,1,2.34,0l102.63,59.2a.7.7,0,0,1,.45.9A.72.72,0,0,1,265.61,137.91Z",
    transform: "translate(-21.75 -18.24)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-64-5",
    "data-name": "freepik--shadow--inject-64",
    className: "cls-6",
    d: "M193.54,137.12l-14.95,8.65a1.84,1.84,0,0,1-1.68,0L132.72,120.3a.52.52,0,0,1-.33-.65.5.5,0,0,1,.33-.32l14.95-8.66a1.84,1.84,0,0,1,1.68,0l44.19,25.48a.52.52,0,0,1,.29.67A.57.57,0,0,1,193.54,137.12Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-64-2",
    "data-name": "freepik--keyboard--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M133.62,117.79a.59.59,0,0,1,.35-.48L148,109.2a1.84,1.84,0,0,1,1.68,0L192.58,134a.6.6,0,0,1,.35.49V136a.59.59,0,0,1-.35.49l-14,8.11a1.84,1.84,0,0,1-1.68,0L134,119.78a.59.59,0,0,1-.35-.48Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M178.54,143l14-8.08a.51.51,0,0,0,.33-.64.54.54,0,0,0-.33-.33L149.7,109.2a1.84,1.84,0,0,0-1.68,0L134,117.31a.52.52,0,0,0-.32.65.51.51,0,0,0,.32.32L176.86,143A1.84,1.84,0,0,0,178.54,143Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M177.75,143.24v1.5a1.7,1.7,0,0,0,.79-.19l14-8.11a.59.59,0,0,0,.35-.49v-1.47a.59.59,0,0,1-.35.48l-14,8.08A1.85,1.85,0,0,1,177.75,143.24Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136.23,117.9h0l1.38-.8,1.89,1.09-1.4.83-1.89-1.09Zm2.17-1.25h0l1.4-.81,1.48.86-1.4.79-1.48-.86Zm.46,2.78h0l1.4-.81,1.48.86-1.4.83-1.48-.86Zm1.72-4h0l1.4-.8,2.39,1.39-1.4.82-2.39-1.38Zm0,2.55h0l1.39-.81,1.18.68-1.39.8-1.18-.69Zm.46,2.77h0l1.39-.8,1.49.85-1.41.84-1.48-.86Zm1.47-1.66h0l1.39-.8,1.14.68-1.39.83-1.15-.68Zm.2-4.92h0l1.39-.8,1.88,1.09-1.38.79-1.89-1.09Zm.57,7.87h0l1.39-.8,10.71,6.18-1.4.83-10.71-6.18Zm.4-4.8h0l1.39-.8,1.14.68-1.39.83-1.18-.68Zm.76,3h0l1.39-.8,1.18.68-1.4.83-1.18-.68Zm.44-7.28h0l1.39-.8,1.18.68-1.4.83-1.16-.71Zm.46,2.78h0l1.39-.8,1.18.68-1.39.78-1.18-.67Zm.26,2.66h0l1.39-.8,1.17.68-1.4.83-1.17-.68Zm.76,3h0l1.39-.8,1.15.68-1.4.83-1.15-.68Zm.45-7.29h0l1.39-.8,1.18.68-1.4.83-1.15-.68Zm.46,2.78h0l1.39-.8,1.18.68-1.4.83-1.18-.68Zm.26,2.66h0l1.38-.8,1.15.68-1.4.83-1.14-.68Zm0-8.07h0l1.38-.81,1.49.86-1.41.83-1.47-.85Zm.76,11h0l1.39-.8,1.17.68-1.4.83-1.17-.68Zm.45-7.28h0l1.38-.81,1.19.69-1.39.76-1.18-.68Zm.46,2.78h0l1.38-.81,1.18.68-1.4.83-1.18-.72Zm.25,2.66h0l1.39-.81,1.18.69-1.4.82-1.18-.67Zm.77,3h0l1.38-.81,1.15.68-1.4.84-1.15-.69Zm.37-10.38h0l1.4-.8,1.17.67-1.4.83-1.17-.67Zm.07,3.09h0l1.39-.8,1.18.68-1.39.79-1.15-.67Zm.46,2.78h0l1.39-.8,1.18.67-1.4.83-1.17-.67Zm.26,2.66h0l1.39-.8,1.14.68-1.4.82-1.14-.67Zm.76,3h0l1.4-.85,1.15.69-1.4.83-1.18-.68Zm.38-10.38h0l1.39-.8,1.18.67-1.4.84-1.15-.68Zm.07,3.09h0l1.39-.8,1.18.68-1.39.78-1.15-.68Zm.46,2.78h0l1.39-.8,1.18.68-1.4.83-1.18-.68Zm.26,2.66h0l1.39-.8,1.17.68-1.39.83-1.18-.68Zm.76,3h0l1.39-.81,1.17.68-1.4.83-1.17-.68Zm.38-10.38h0l1.39-.8,1.18.68-1.4.83-1.18-.68Zm.07,3.09h0l1.39-.8,1.17.68-1.4.83-1.15-.68Zm.21,10.18h0l1.39-.8,1.48.86-1.4.83-1.48-.86Zm.24-7.4h0l1.39-.8,1.18.68-1.4.83-1.17-.68Zm.26,2.66h0l1.4-.8,1.15.64-1.4.82-1.17-.67Zm.76,3h0l1.39-.8,1.18.68-1.4.83-1.18-.68Zm.38-10.37h0l1.4-.81,1.16.66-1.4.83-1.17-.67Zm.07,3.09h0l1.4-.81,1.17.68-1.4.83-1.17-.68Zm.46,2.78h0l1.39-.81,1.15.68-1.4.83-1.15-.68Zm.06,7.57h0l1.39-.8,1.48.85-1.4.83L157,130Zm.2-4.91h0l1.39-.81,1.14.69-1.33.77-1.15-.67Zm.76,3h0l1.39-.8,1.18.68-1.41.83L158,128Zm.45-7.28h0l1.39-.81,1.15.69-1.4.82-1.15-.72Zm.46,2.78h0l1.39-.8,1.18.67-1.4.83-1.18-.67Zm.25,2.66h0l1.39-.8,1.18.68-1.4.82-1.17-.74Zm.06-8h0l1.4-.8,1.17.68-1.4.83-1.17-.75Zm.05,13.14h0l1.39-.81,1.48.86-1.41.77-1.48-.86Zm.66-2.14h0l1.38-.81,1.19.69-1.41.83-1.15-.68Zm.44-7.28h0l1.39-.81,1.18.69-1.4.82-1.17-.67Zm.46,2.78h0l1.4-.81,1.17.68-1.4.83-1.17-.67Zm.26,2.66h0l1.39-.81,1.18.69-1.41.82-1.16-.73Zm.06-8h0l1.39-.8,1.18.68-1.4.83-1.15-.68Zm.35,13.31h0l1.4-.81,1.88,1.09-1.4.84-1.88-1.09Zm.35-2.29h0l1.39-.81,3.72,2.15-1.4.83-3.68-2.24Zm.45-7.29h0l1.39-.8,1.18.68-1.4.83-1.17-.68Zm.46,2.78h0l1.39-.8,1.17.57-1.4.84-1.18-.68Zm.26,2.66h0l1.38-.8,1.19.68-1.42.73-1.15-.67Zm0-8h0l1.4-.8,1.17.68-1.4.83-1.17-.68Zm1.15,3.71h0l1.39-.8,1.18.68-1.4.83-1.17-.68Zm.32,10.24h0l1.38-.8,1.18.68-1.4.83-1.15-.68Zm.14-7.45h0l1.39-.8,1.15.67-1.33.71-1.15-.67Zm.26,2.66h0l1.39-.8,1.07.62a.8.8,0,0,0,.34.07.89.89,0,0,0,.36-.07l1.83-1.06,1.37.8-3.57,2.08-2.8-1.61Zm.06-8h0l1.39-.8,1.17.68-1.38.68-1.18-.68Zm1.14,3.72h0l1.39-.8,1.18.68-1.4.82-1.15-.67Zm.32,10.24h0l1.38-.81,1.19.68-1.41.83-1.15-.67Zm.14-7.46h0l1.39-.8,1.18.68-1.4.83-1.18-.68Zm1.15-4.9h0l1.38-.8,1.19.68-1.41.83-1.17-.68Zm.31,3.24h0l1.39-.81,1.18.69-1.4.82-1.17-.68Zm.32,10.23h0l1.39-.8,1.18.68-1.41.83-1.15-.68Zm.25-2.36h0l1.39-.81,1.18.69-1.41.83-1.14-.82Zm1-10h0l1.39-.8,1.18.68-1.4.83-1.18-.68Zm.32,3.24h0l1.39-.8,2.09,1.2-1.4.83-2.09-1.2Zm.72,10.47h0l1.39-.8,3.11,1.79-1.41.83-3.1-1.79Zm.35-7.34h0l1.39-.8,1.17.68-1.4.82-1.17-.67Zm.54-5.25h0l1.39-.81,1.17.68-1.39.69-1.15-.68Zm1.29,11.34h0l1.39-.81,1.18.69-1.4.83-1.18-.68Zm.09-5h0l1.39-.8,1.15.68-1.4.83-1.14-.68Zm.25-2.37h0l1.4-.8,1.14.68-1.4.83-1.14-.68Zm.3-2.86h0l1.38-.81,1.15.68-1.4.83-1.15-.68Zm1,13.7h0l1.39-.8,1.18.68-1.4.83-1.15-.68Zm.26-2.36h0l1.39-.81,1.15.69-1.4.83-1.15-.69Zm.09-5h0l1.39-.8,1.18.68-1.4.82-1.18-.67Zm.16,2.6h0l1.39-.8,1.15.68-1.4.83-1.15-.68Zm.09-5h0l1.39-.8,1.18.68-1.4.83-1.18-.68Zm.72-2.64h0l1.38-.8,1.18.68-1.37.68-1.17-.68Zm.61,13.47h0l3.57-2.07,1.17.68L177.63,142l-1.18-.68Zm.25-2.37h0l1.4-.8,1.17.68-1.38.66-1.15-.68Zm.25-2.38h0l1.4-.8,1.17.68-1.4.83-1.15-.84Zm.1-5h0l1.39-.8,1.17.68-1.39.83-1.18-.68Zm.15,2.61h0l1.39-.81,1.18.68-1.4.83-1.17-.67Zm.57-5.24h0l1.39-.81,1.18.68-1.4.83-1.17-.67Zm1.12,8.72h0l1.4-.81,1.17.69-1.4.83-1.16-.82Zm.25-2.37h0l1.39-.8,1.18.67-1.38.67-1.18-.67Zm.25-2.37h0l1.39-.8,1.18.68-1.41.83-1.14-.68Zm.31-2.87h0l1.39-.8,1.18.68-1.4.83-1.18-.68Zm1.12,8.72h0l3.57-2.05,1.18.67-3.58,2.1-1.18-.69Zm.24-2.36h0l1.4-.81,1.17.68-1.4.83-1.17-.67Zm.26-2.37h0l1.38-.8,1.19.67-1.41.67-1.15-.68Zm1.28-3h0l.57-.35,1.18.68-.61.37-1.14-.68Zm.64,4.07h0l1.39-.8,1.18.68-1.4.83-1.15-.68Zm1.28-3h0l.58-.35,1.18.68-.61.37-1.15-.67Zm.65,4.07h0l1.39-.8,1.18.68-1.41.83-1.14-.68Zm1.28-3h0L187,133l1.18.68-.61.37-1.14-.67Zm1.92,1.11h0l.57-.35,1.18.68-.6.38-1.15-.68Z",
    transform: "translate(-21.75 -18.24)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-64-6",
    "data-name": "freepik--shadow--inject-64",
    className: "cls-6",
    points: "206.36 120.56 219.52 112.96 153.72 74.98 140.57 82.57 206.36 120.56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M190.85,126.43,181.46,121a2.5,2.5,0,0,1-1.46-2v-1.3l8.84-5a2.09,2.09,0,0,0,.94-1.62V99.45l16.41,9.48v11.58a2.09,2.09,0,0,1-.94,1.62l-7.38,4.3A7.75,7.75,0,0,1,190.85,126.43Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M202.25,122.56v1.3l3-1.72a2.09,2.09,0,0,0,.94-1.62V108.94l-3.13-1.81c-.06.8-.14,1.62-.2,2.42l2.19,1.27v9.05a2,2,0,0,1-.93,1.62Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.05,119.86a2,2,0,0,1-.93,1.62l-6.25,3.64a7.75,7.75,0,0,1-7,0l-9.4-5.43c-1.93-1.11-1.93-2.93,0-4l6.26-3.64a2,2,0,0,0,.93-1.62v-9l16.41,9.48Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M185.8,113.1h0l1.91-1.1a2,2,0,0,0,.93-1.62v-9l16.41,9.48v9a2,2,0,0,1-.93,1.62l-1.87,1.08Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M180,117.67V119a2.48,2.48,0,0,0,1.45,2l9.4,5.43a7.1,7.1,0,0,0,3.35.83V126a7.11,7.11,0,0,1-3.35-.84l-9.4-5.43A2.48,2.48,0,0,1,180,117.67Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M231.4,132.35a2.49,2.49,0,0,1-2.27,0L165.68,95.7a2.55,2.55,0,0,1-1.15-2V38.11a2.2,2.2,0,0,1,2.11-2.28,2.13,2.13,0,0,1,1.25.34l63.46,36.64a2.54,2.54,0,0,1,1.14,2v55.54A2.46,2.46,0,0,1,231.4,132.35Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M229.13,132.31,165.68,95.7a2.55,2.55,0,0,1-1.15-2V38.1c0-.74.52-1,1.15-.67l63.45,36.64a2.55,2.55,0,0,1,1.15,2v55.55C230.3,132.39,229.78,132.68,229.13,132.31Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M229.31,132.54a2.17,2.17,0,0,0,2.94-.93,2.11,2.11,0,0,0,.24-1.1v-6.25l-2.19,1.25v6.25C230.3,132.46,229.87,132.77,229.31,132.54Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M230.3,125.51v6.25c0,.75-.52,1.05-1.14.68L165.68,95.82a2.58,2.58,0,0,1-1.15-2V87.54Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M228.11,120.78v-44a1.58,1.58,0,0,0-.7-1.22L167.4,41c-.38-.22-.7,0-.7.41v44a1.57,1.57,0,0,0,.7,1.21l60,34.65C227.78,121.41,228.11,121.23,228.11,120.78Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M228.11,120.78v-44a1.58,1.58,0,0,0-.7-1.22L167.4,41c-.38-.22-.7,0-.7.41v44a1.57,1.57,0,0,0,.7,1.21l60,34.65C227.78,121.41,228.11,121.23,228.11,120.78Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.39,108.93a2.44,2.44,0,0,1,1.1,1.9c0,.7-.5,1-1.1.63a2.42,2.42,0,0,1-1.1-1.9C196.31,108.89,196.82,108.58,197.39,108.93Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M230,74.94a2.44,2.44,0,0,1,.34,1.14v49.43l2.19-1.26V74.83a2.33,2.33,0,0,0-.34-1.15Z",
    transform: "translate(-21.75 -18.24)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-64-2",
    "data-name": "freepik--window--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.89,26.64v-.11h0v-.09a.47.47,0,0,1,.06-.15.1.1,0,0,1,0-.05l0,0a.3.3,0,0,1,.08-.08h0l.09-.06a.83.83,0,0,1,.75.1L250,68.9a2.47,2.47,0,0,1,1.12,1.94v53.6h0v.24a.75.75,0,0,1-.4.67l-.05,0-.06,0h-.1a.33.33,0,0,1-.14,0,.7.7,0,0,1-.37-.11h0l-1-.6L176,82.59a2.51,2.51,0,0,1-1.12-1.94V26.76S174.89,26.68,174.89,26.64Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M175.25,26a.8.8,0,0,1,.75.09l74.06,42.74a2.49,2.49,0,0,1,1.12,1.94v3.68l1.43-.84V70a2.49,2.49,0,0,0-1.12-1.93L177.43,25.32a.79.79,0,0,0-.81-.06Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M174.88,26.77c0-.71.51-1,1.12-.64l74.06,42.74a2.47,2.47,0,0,1,1.12,1.94v3.68l-76.3-44Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M176,26.13l74.06,42.74a2.33,2.33,0,0,1,.79.83l1.42-.82a2.27,2.27,0,0,0-.78-.82L177.43,25.32a.79.79,0,0,0-.81-.06l-1.36.78A.78.78,0,0,1,176,26.13Z",
    transform: "translate(-21.75 -18.24)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M252.61,73.63V70a2.24,2.24,0,0,0-.34-1.15l-1.42.82a2.18,2.18,0,0,1,.33,1.11v3.71Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M248.66,69.64a1.69,1.69,0,0,1,.63,1.34c0,.54-.28.81-.63.61a1.67,1.67,0,0,1-.64-1.34C248,69.72,248.31,69.44,248.66,69.64Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M246.38,68.33a1.64,1.64,0,0,1,.63,1.33c0,.54-.28.81-.63.61a1.64,1.64,0,0,1-.63-1.33C245.75,68.4,246,68.13,246.38,68.33Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M244.1,67a1.66,1.66,0,0,1,.63,1.34c0,.53-.28.81-.63.61a1.7,1.7,0,0,1-.63-1.34C243.47,67.08,243.75,66.81,244.1,67Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M250.78,125.34l.05,0,1.18-.68a1.17,1.17,0,0,0,.58-.87V73.63l-1.44.84v50.19a.72.72,0,0,1-.34.64h0Z",
    transform: "translate(-21.75 -18.24)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.57,49.52l15.61,9a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-15.61-9a.87.87,0,0,1-.4-.66C197.17,49.48,197.35,49.39,197.57,49.52Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.54,66.74l5.89,3.41a.83.83,0,0,1,.4.65c0,.24-.18.33-.4.21l-5.89-3.4a.8.8,0,0,1-.4-.66C203.12,66.71,203.31,66.61,203.54,66.74Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.54,70.19l5.89,3.4a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2l-5.89-3.4a.85.85,0,0,1-.4-.66C203.12,70.15,203.31,70.06,203.54,70.19Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M214.72,59.4,246,77.4a.88.88,0,0,1,.4.67c0,.23-.18.33-.4.2l-31.26-18a.87.87,0,0,1-.39-.67C214.33,59.37,214.5,59.28,214.72,59.4Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M203.66,90.89l9.52,5.51a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2l-9.52-5.51a.84.84,0,0,1-.39-.66C203.27,90.86,203.45,90.77,203.66,90.89Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M214.72,97.29l31.26,18a.83.83,0,0,1,.4.65c0,.25-.18.33-.4.21l-31.26-18a.84.84,0,0,1-.39-.66C214.33,97.25,214.5,97.16,214.72,97.29Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.57,53l7.85,4.52a.84.84,0,0,1,.39.66c0,.24-.17.33-.39.2l-7.85-4.5a.85.85,0,0,1-.4-.66C197.17,52.93,197.35,52.84,197.57,53Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M197.57,53l7.85,4.52a.84.84,0,0,1,.39.66c0,.24-.17.33-.39.2l-7.85-4.5a.85.85,0,0,1-.4-.66C197.17,52.93,197.35,52.84,197.57,53Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.57,56.41l3.68,2.12a.81.81,0,0,1,.39.66c0,.23-.17.33-.39.2l-3.68-2.1a.85.85,0,0,1-.4-.66C197.17,56.37,197.35,56.28,197.57,56.41Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M197.57,56.41l3.68,2.12a.81.81,0,0,1,.39.66c0,.23-.17.33-.39.2l-3.68-2.1a.85.85,0,0,1-.4-.66C197.17,56.37,197.35,56.28,197.57,56.41Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.57,63.29l3.68,2.13a.84.84,0,0,1,.39.66c0,.24-.17.33-.39.2l-3.68-2.12a.87.87,0,0,1-.4-.66C197.17,63.26,197.35,63.17,197.57,63.29Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M197.57,63.29l3.68,2.13a.84.84,0,0,1,.39.66c0,.24-.17.33-.39.2l-3.68-2.12a.87.87,0,0,1-.4-.66C197.17,63.26,197.35,63.17,197.57,63.29Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.57,66.74l3.68,2.12a.83.83,0,0,1,.39.66c0,.24-.17.33-.39.2l-3.68-2.12a.85.85,0,0,1-.4-.66C197.17,66.71,197.35,66.61,197.57,66.74Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M197.57,66.74l3.68,2.12a.83.83,0,0,1,.39.66c0,.24-.17.33-.39.2l-3.68-2.12a.85.85,0,0,1-.4-.66C197.17,66.71,197.35,66.61,197.57,66.74Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M207,58.38l4.71,2.73a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2L207,59.24a.82.82,0,0,1-.4-.66C206.56,58.34,206.75,58.25,207,58.38Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M207,58.38l4.71,2.73a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2L207,59.24a.82.82,0,0,1-.4-.66C206.56,58.34,206.75,58.25,207,58.38Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M214.27,83.28,246,101.54a.85.85,0,0,1,.4.66c0,.23-.18.33-.4.2L214.27,84.14a.85.85,0,0,1-.4-.66C213.87,83.24,214.05,83.15,214.27,83.28Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M241.27,95.36,246,98.09a.85.85,0,0,1,.4.66c0,.24-.18.32-.4.2l-4.71-2.73a.87.87,0,0,1-.4-.66C240.87,95.32,241.05,95.23,241.27,95.36Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M208,76.21l31.71,18.26a.87.87,0,0,1,.4.67c0,.23-.18.32-.4.2L208,77.07a.87.87,0,0,1-.4-.66C207.61,76.17,207.79,76.08,208,76.21Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M203.54,59.85l7.86,4.52a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2l-7.86-4.5a.85.85,0,0,1-.4-.66C203.12,59.81,203.31,59.72,203.54,59.85Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M203.54,59.85l7.86,4.52a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2l-7.86-4.5a.85.85,0,0,1-.4-.66C203.12,59.81,203.31,59.72,203.54,59.85Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M212.94,65.26l32.81,19a.84.84,0,0,1,.39.66c0,.24-.17.33-.39.2l-32.81-19a.85.85,0,0,1-.4-.66C212.54,65.22,212.72,65.13,212.94,65.26Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M212.94,65.26l32.81,19a.84.84,0,0,1,.39.66c0,.24-.17.33-.39.2l-32.81-19a.85.85,0,0,1-.4-.66C212.54,65.22,212.72,65.13,212.94,65.26Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.54,80.59,246,105.06a.87.87,0,0,1,.4.66c0,.24-.18.34-.4.21L203.54,81.45a.85.85,0,0,1-.42-.65C203.12,80.55,203.31,80.46,203.54,80.59Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.57,77.15l3.68,2.12a.81.81,0,0,1,.39.66c0,.24-.17.32-.39.2L197.57,78a.87.87,0,0,1-.4-.66C197.17,77.11,197.35,77,197.57,77.15Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M197.57,77.15l3.68,2.12a.81.81,0,0,1,.39.66c0,.24-.17.32-.39.2L197.57,78a.87.87,0,0,1-.4-.66C197.17,77.11,197.35,77,197.57,77.15Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.54,84,246,108.51a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2L203.54,84.89a.85.85,0,0,1-.42-.65C203.12,84,203.31,83.9,203.54,84Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.57,80.59l3.68,2.12a.83.83,0,0,1,.39.66c0,.24-.17.33-.39.2l-3.68-2.12a.85.85,0,0,1-.4-.66C197.17,80.55,197.35,80.46,197.57,80.59Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M197.57,80.59l3.68,2.12a.83.83,0,0,1,.39.66c0,.24-.17.33-.39.2l-3.68-2.12a.85.85,0,0,1-.4-.66C197.17,80.55,197.35,80.46,197.57,80.59Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.54,87.48,246,112a.83.83,0,0,1,.4.66c0,.23-.18.32-.4.2L203.54,88.34a.87.87,0,0,1-.42-.66C203.12,87.44,203.31,87.35,203.54,87.48Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.57,84l3.68,2.12a.83.83,0,0,1,.39.66c0,.24-.17.33-.39.21l-3.68-2.13a.85.85,0,0,1-.4-.66C197.17,84,197.35,83.9,197.57,84Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M197.57,84l3.68,2.12a.83.83,0,0,1,.39.66c0,.24-.17.33-.39.21l-3.68-2.13a.85.85,0,0,1-.4-.66C197.17,84,197.35,83.9,197.57,84Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M191.84,46.06,194,47.31a.89.89,0,0,1,.39.68v.8c0,.25-.18.35-.39.22l-2.16-1.25a.86.86,0,0,1-.4-.67v-.8C191.44,46,191.62,45.94,191.84,46.06Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M191.84,49.54,194,50.79a.88.88,0,0,1,.39.68v.79c0,.26-.18.35-.39.23l-2.16-1.25a.86.86,0,0,1-.4-.68v-.8C191.44,49.52,191.62,49.41,191.84,49.54Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M191.84,53,194,54.26a.91.91,0,0,1,.39.69v.79c0,.25-.18.35-.39.23l-2.16-1.25a.86.86,0,0,1-.4-.68v-.8C191.44,53,191.62,52.89,191.84,53Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M191.84,56.5,194,57.74a.91.91,0,0,1,.39.68v.8c0,.25-.18.35-.39.23l-2.16-1.25a.88.88,0,0,1-.4-.68v-.8C191.44,56.47,191.62,56.37,191.84,56.5Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M191.84,60,194,61.22a.88.88,0,0,1,.39.68v.79c0,.25-.18.36-.39.23l-2.16-1.25a.86.86,0,0,1-.4-.67v-.8C191.44,60,191.62,59.84,191.84,60Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M191.84,63.45,194,64.7a.88.88,0,0,1,.39.68v.79c0,.25-.18.35-.39.23l-2.16-1.25a.86.86,0,0,1-.4-.68v-.8C191.44,63.43,191.62,63.32,191.84,63.45Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M191.84,66.92,194,68.17a.91.91,0,0,1,.39.69v.79c0,.25-.18.35-.39.23l-2.16-1.25a.86.86,0,0,1-.4-.68v-.8C191.44,66.9,191.62,66.8,191.84,66.92Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M191.84,70.4,194,71.65a.88.88,0,0,1,.39.68v.8c0,.25-.18.35-.39.22l-2.16-1.24a.89.89,0,0,1-.4-.69v-.79C191.44,70.38,191.62,70.28,191.84,70.4Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M191.84,73.88,194,75.13a.88.88,0,0,1,.39.68v.79c0,.25-.18.36-.39.23l-2.16-1.25a.86.86,0,0,1-.4-.68v-.79C191.44,73.85,191.62,73.75,191.84,73.88Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M191.84,77.36,194,78.61a.87.87,0,0,1,.39.67v.8c0,.25-.18.35-.39.22l-2.16-1.22a.88.88,0,0,1-.4-.68v-.8C191.44,77.36,191.62,77.23,191.84,77.36Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M191.84,80.83,194,82.08a.89.89,0,0,1,.39.68v.79c0,.26-.18.36-.39.23l-2.16-1.26a.88.88,0,0,1-.4-.69V81C191.44,80.8,191.62,80.71,191.84,80.83Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M191.84,84.31,194,85.56a.88.88,0,0,1,.39.68V87c0,.26-.18.35-.39.23L191.84,86a.86.86,0,0,1-.4-.68v-.79C191.44,84.29,191.62,84.19,191.84,84.31Z",
    transform: "translate(-21.75 -18.24)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M177.49,34.77l11.69,6.75a1.72,1.72,0,0,1,.79,1.36V56.39c0,.49-.35.7-.79.45l-11.69-6.75a1.72,1.72,0,0,1-.79-1.36V35.23C176.7,34.72,177.05,34.52,177.49,34.77Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M178.57,48.15l1.08.63a.85.85,0,0,1,.4.66c0,.24-.18.32-.4.2L178.57,49a.85.85,0,0,1-.4-.66C178.17,48.12,178.35,48,178.57,48.15Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M178.57,48.15l1.08.63a.85.85,0,0,1,.4.66c0,.24-.18.32-.4.2L178.57,49a.85.85,0,0,1-.4-.66C178.17,48.12,178.35,48,178.57,48.15Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M178.57,37.09l1.08.63a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2L178.57,38a.87.87,0,0,1-.4-.66C178.17,37.06,178.35,37,178.57,37.09Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M178.57,37.09l1.08.63a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2L178.57,38a.87.87,0,0,1-.4-.66C178.17,37.06,178.35,37,178.57,37.09Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.08,40.18l1.08.62a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2L180.08,41a.86.86,0,0,1-.39-.66C179.69,40.14,179.87,40.05,180.08,40.18Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M180.08,40.18l1.08.62a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2L180.08,41a.86.86,0,0,1-.39-.66C179.69,40.14,179.87,40.05,180.08,40.18Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.08,42.39l1.08.62a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.84.84,0,0,1-.39-.66C179.69,42.35,179.87,42.25,180.08,42.39Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M180.08,42.39l1.08.62a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.84.84,0,0,1-.39-.66C179.69,42.35,179.87,42.25,180.08,42.39Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M178.57,43.73l1.08.62a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.85.85,0,0,1-.4-.66C178.17,43.69,178.35,43.6,178.57,43.73Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M178.57,43.73l1.08.62a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.85.85,0,0,1-.4-.66C178.17,43.69,178.35,43.6,178.57,43.73Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.08,46.81l1.08.63a.85.85,0,0,1,.4.66c0,.23-.18.32-.4.2l-1.08-.63a.84.84,0,0,1-.39-.66C179.69,46.78,179.87,46.69,180.08,46.81Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M180.08,46.81l1.08.63a.85.85,0,0,1,.4.66c0,.23-.18.32-.4.2l-1.08-.63a.84.84,0,0,1-.39-.66C179.69,46.78,179.87,46.69,180.08,46.81Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M181.52,38.8l6.57,3.8a.8.8,0,0,1,.4.66c0,.23-.17.32-.4.2l-6.57-3.8a.85.85,0,0,1-.4-.66C181.12,38.76,181.3,38.67,181.52,38.8Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M181.52,38.8l6.57,3.8a.8.8,0,0,1,.4.66c0,.23-.17.32-.4.2l-6.57-3.8a.85.85,0,0,1-.4-.66C181.12,38.76,181.3,38.67,181.52,38.8Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M181.52,49.84l6.57,3.8a.8.8,0,0,1,.4.66c0,.23-.17.33-.4.2l-6.57-3.8a.85.85,0,0,1-.4-.66C181.12,49.84,181.3,49.73,181.52,49.84Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M181.52,49.84l6.57,3.8a.8.8,0,0,1,.4.66c0,.23-.17.33-.4.2l-6.57-3.8a.85.85,0,0,1-.4-.66C181.12,49.84,181.3,49.73,181.52,49.84Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M183.06,41.88l5.06,2.93a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2l-5.06-2.93a.85.85,0,0,1-.4-.66C182.63,41.84,182.81,41.76,183.06,41.88Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M183.06,41.88l5.06,2.93a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2l-5.06-2.93a.85.85,0,0,1-.4-.66C182.63,41.84,182.81,41.76,183.06,41.88Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M183.06,44.11,188.12,47a.83.83,0,0,1,.4.65c0,.25-.18.33-.4.21L183.06,45a.83.83,0,0,1-.4-.65C182.63,44.05,182.81,44,183.06,44.11Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M183.06,44.11,188.12,47a.83.83,0,0,1,.4.65c0,.25-.18.33-.4.21L183.06,45a.83.83,0,0,1-.4-.65C182.63,44.05,182.81,44,183.06,44.11Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M181.52,45.44l6.57,3.79a.85.85,0,0,1,.4.66c0,.24-.17.33-.4.2l-6.57-3.79a.87.87,0,0,1-.4-.66C181.12,45.4,181.3,45.31,181.52,45.44Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M181.52,45.44l6.57,3.79a.85.85,0,0,1,.4.66c0,.24-.17.33-.4.2l-6.57-3.79a.87.87,0,0,1-.4-.66C181.12,45.4,181.3,45.31,181.52,45.44Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M183.06,48.51l5.06,2.93a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-5.06-2.93a.83.83,0,0,1-.4-.65C182.63,48.48,182.81,48.39,183.06,48.51Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M183.06,48.51l5.06,2.93a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-5.06-2.93a.83.83,0,0,1-.4-.65C182.63,48.48,182.81,48.39,183.06,48.51Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M177.49,52.63l11.69,6.75a1.71,1.71,0,0,1,.79,1.35V87.41c0,.51-.35.71-.79.46l-11.69-6.76a1.71,1.71,0,0,1-.79-1.36V53.08C176.7,52.58,177.05,52.38,177.49,52.63Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M178.57,55l1.08.62a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.85.85,0,0,1-.4-.66C178.17,54.92,178.35,54.83,178.57,55Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M178.57,55l1.08.62a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.85.85,0,0,1-.4-.66C178.17,54.92,178.35,54.83,178.57,55Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.08,58l1.08.62a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.86.86,0,0,1-.39-.66C179.69,58,179.87,57.91,180.08,58Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M180.08,58l1.08.62a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.86.86,0,0,1-.39-.66C179.69,58,179.87,57.91,180.08,58Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.08,60.24l1.08.62a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.82.82,0,0,1-.39-.65C179.69,60.2,179.87,60.11,180.08,60.24Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M180.08,60.24l1.08.62a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.82.82,0,0,1-.39-.65C179.69,60.2,179.87,60.11,180.08,60.24Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M178.57,61.59l1.08.62a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.85.85,0,0,1-.4-.66C178.17,61.55,178.35,61.46,178.57,61.59Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M178.57,61.59l1.08.62a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.85.85,0,0,1-.4-.66C178.17,61.55,178.35,61.46,178.57,61.59Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M181.52,56.66l6.57,3.8a.79.79,0,0,1,.4.66c0,.23-.17.32-.4.2l-6.57-3.8a.85.85,0,0,1-.4-.66C181.12,56.62,181.3,56.53,181.52,56.66Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M181.52,56.66l6.57,3.8a.79.79,0,0,1,.4.66c0,.23-.17.32-.4.2l-6.57-3.8a.85.85,0,0,1-.4-.66C181.12,56.62,181.3,56.53,181.52,56.66Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M183.06,59.74l5.06,2.93a.85.85,0,0,1,.4.66c0,.23-.18.33-.4.2l-5.06-2.93a.85.85,0,0,1-.4-.66C182.63,59.7,182.81,59.61,183.06,59.74Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M183.06,59.74l5.06,2.93a.85.85,0,0,1,.4.66c0,.23-.18.33-.4.2l-5.06-2.93a.85.85,0,0,1-.4-.66C182.63,59.7,182.81,59.61,183.06,59.74Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M183.06,62l5.06,2.93a.83.83,0,0,1,.4.66c0,.24-.18.33-.4.2l-5.06-2.93a.85.85,0,0,1-.4-.66C182.63,61.91,182.81,61.82,183.06,62Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M183.06,62l5.06,2.93a.83.83,0,0,1,.4.66c0,.24-.18.33-.4.2l-5.06-2.93a.85.85,0,0,1-.4-.66C182.63,61.91,182.81,61.82,183.06,62Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M181.52,63.29l6.57,3.8a.85.85,0,0,1,.4.66c0,.24-.17.33-.4.2l-6.57-3.78a.85.85,0,0,1-.4-.66C181.12,63.25,181.3,63.17,181.52,63.29Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M181.52,63.29l6.57,3.8a.85.85,0,0,1,.4.66c0,.24-.17.33-.4.2l-6.57-3.78a.85.85,0,0,1-.4-.66C181.12,63.25,181.3,63.17,181.52,63.29Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.08,64.68l1.08.63a.85.85,0,0,1,.4.66c0,.24-.18.32-.4.2l-1.08-.62a.86.86,0,0,1-.39-.66C179.69,64.65,179.87,64.56,180.08,64.68Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M180.08,64.68l1.08.63a.85.85,0,0,1,.4.66c0,.24-.18.32-.4.2l-1.08-.62a.86.86,0,0,1-.39-.66C179.69,64.65,179.87,64.56,180.08,64.68Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.08,66.89l1.08.62a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.86.86,0,0,1-.39-.66C179.69,66.85,179.87,66.76,180.08,66.89Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M180.08,66.89l1.08.62a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.86.86,0,0,1-.39-.66C179.69,66.85,179.87,66.76,180.08,66.89Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M183.06,66.38l5.06,2.93a.87.87,0,0,1,.4.66c0,.24-.18.34-.4.2l-5.06-2.92a.85.85,0,0,1-.4-.66C182.63,66.35,182.81,66.26,183.06,66.38Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M183.06,66.38l5.06,2.93a.87.87,0,0,1,.4.66c0,.24-.18.34-.4.2l-5.06-2.92a.85.85,0,0,1-.4-.66C182.63,66.35,182.81,66.26,183.06,66.38Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M183.06,68.6l5.06,2.93a.83.83,0,0,1,.4.66c0,.24-.18.32-.4.2l-5.06-2.93a.85.85,0,0,1-.4-.66C182.63,68.56,182.81,68.47,183.06,68.6Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M183.06,68.6l5.06,2.93a.83.83,0,0,1,.4.66c0,.24-.18.32-.4.2l-5.06-2.93a.85.85,0,0,1-.4-.66C182.63,68.56,182.81,68.47,183.06,68.6Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M178.57,72.67l1.08.63a.85.85,0,0,1,.4.66c0,.23-.18.32-.4.2l-1.08-.63a.85.85,0,0,1-.4-.66C178.17,72.64,178.35,72.55,178.57,72.67Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M178.57,72.67l1.08.63a.85.85,0,0,1,.4.66c0,.23-.18.32-.4.2l-1.08-.63a.85.85,0,0,1-.4-.66C178.17,72.64,178.35,72.55,178.57,72.67Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M181.52,74.38l6.57,3.8a.79.79,0,0,1,.4.66c0,.23-.17.32-.4.2l-6.57-3.8a.85.85,0,0,1-.4-.66C181.12,74.34,181.3,74.25,181.52,74.38Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M181.52,74.38l6.57,3.8a.79.79,0,0,1,.4.66c0,.23-.17.32-.4.2l-6.57-3.8a.85.85,0,0,1-.4-.66C181.12,74.34,181.3,74.25,181.52,74.38Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.08,75.77l1.08.62a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.84.84,0,0,1-.39-.66C179.69,75.73,179.87,75.64,180.08,75.77Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M180.08,75.77l1.08.62a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.84.84,0,0,1-.39-.66C179.69,75.73,179.87,75.64,180.08,75.77Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.08,78l1.08.62a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.86.86,0,0,1-.39-.66C179.69,77.93,179.87,77.85,180.08,78Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M180.08,78l1.08.62a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2l-1.08-.62a.86.86,0,0,1-.39-.66C179.69,77.93,179.87,77.85,180.08,78Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M183.06,77.47l5.06,2.93a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2l-5.06-2.93a.85.85,0,0,1-.4-.66C182.63,77.44,182.81,77.36,183.06,77.47Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M183.06,77.47l5.06,2.93a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2l-5.06-2.93a.85.85,0,0,1-.4-.66C182.63,77.44,182.81,77.36,183.06,77.47Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M183.06,79.69l5.06,2.92a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-5.06-2.93a.83.83,0,0,1-.4-.65C182.63,79.65,182.81,79.56,183.06,79.69Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M183.06,79.69l5.06,2.92a.87.87,0,0,1,.4.66c0,.24-.18.33-.4.2l-5.06-2.93a.83.83,0,0,1-.4-.65C182.63,79.65,182.81,79.56,183.06,79.69Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.08,69.08l1.08.63a.85.85,0,0,1,.4.66c0,.23-.18.33-.4.2l-1.08-.63a.82.82,0,0,1-.39-.65C179.69,69.05,179.87,69,180.08,69.08Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M180.08,69.08l1.08.63a.85.85,0,0,1,.4.66c0,.23-.18.33-.4.2l-1.08-.63a.82.82,0,0,1-.39-.65C179.69,69.05,179.87,69,180.08,69.08Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M178.57,70.43l1.08.63a.85.85,0,0,1,.4.66c0,.23-.18.32-.4.2l-1.08-.63a.85.85,0,0,1-.4-.66C178.17,70.4,178.35,70.31,178.57,70.43Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M178.57,70.43l1.08.63a.85.85,0,0,1,.4.66c0,.23-.18.32-.4.2l-1.08-.63a.85.85,0,0,1-.4-.66C178.17,70.4,178.35,70.31,178.57,70.43Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M183.06,70.79l5.06,2.93a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2l-5.06-2.93a.83.83,0,0,1-.4-.66C182.63,70.76,182.81,70.67,183.06,70.79Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M183.06,70.79l5.06,2.93a.85.85,0,0,1,.4.66c0,.24-.18.33-.4.2l-5.06-2.93a.83.83,0,0,1-.4-.66C182.63,70.76,182.81,70.67,183.06,70.79Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M181.52,72.13l6.57,3.81a.78.78,0,0,1,.4.65c0,.24-.17.33-.4.21L181.52,73a.85.85,0,0,1-.4-.66C181.12,72.1,181.3,72,181.52,72.13Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M181.52,72.13l6.57,3.81a.78.78,0,0,1,.4.65c0,.24-.17.33-.4.21L181.52,73a.85.85,0,0,1-.4-.66C181.12,72.1,181.3,72,181.52,72.13Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M178.57,79.35l1.08.63a.85.85,0,0,1,.4.66c0,.23-.18.32-.4.2l-1.08-.62a.85.85,0,0,1-.4-.66C178.17,79.32,178.35,79.23,178.57,79.35Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M178.57,79.35l1.08.63a.85.85,0,0,1,.4.66c0,.23-.18.32-.4.2l-1.08-.62a.85.85,0,0,1-.4-.66C178.17,79.32,178.35,79.23,178.57,79.35Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M181.52,81.06l6.57,3.8a.79.79,0,0,1,.4.66c0,.23-.17.32-.4.2l-6.57-3.78a.83.83,0,0,1-.4-.66C181.12,81,181.3,80.93,181.52,81.06Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M181.52,81.06l6.57,3.8a.79.79,0,0,1,.4.66c0,.23-.17.32-.4.2l-6.57-3.78a.83.83,0,0,1-.4-.66C181.12,81,181.3,80.93,181.52,81.06Z",
    transform: "translate(-21.75 -18.24)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-64-3",
    "data-name": "freepik--window--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M242.56,90.14v43.78a2,2,0,0,0,.91,1.58L268.62,150a.68.68,0,0,0,.31.08h.24l.05,0,0,0a.7.7,0,0,0,.17-.24,1,1,0,0,0,.09-.46V105.75a2,2,0,0,0-.91-1.57l-25.15-14.5a.65.65,0,0,0-.62-.08l-.07,0h0l-.06.06a0,0,0,0,0,0,0,.09.09,0,0,0,0,.06.24.24,0,0,0-.06.11V90h0v.09C242.56,90.06,242.56,90.1,242.56,90.14Z",
    transform: "translate(-21.75 -18.24)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M242.85,89.53a.71.71,0,0,1,.62.08l25.15,14.5a2,2,0,0,1,.91,1.58v3l1.46-.84v-2.94a2,2,0,0,0-.92-1.58L244.92,88.82a.63.63,0,0,0-.66,0C244.09,88.82,243.05,89.44,242.85,89.53Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M242.56,90.13c0-.57.41-.8.91-.52l25.15,14.5a2,2,0,0,1,.91,1.58v3L242.59,93.12Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M243.47,89.61l25.15,14.5a1.93,1.93,0,0,1,.65.68l1.44-.83a1.76,1.76,0,0,0-.64-.66L244.92,88.82a.63.63,0,0,0-.66,0l-1.4.79A.63.63,0,0,1,243.47,89.61Z",
    transform: "translate(-21.75 -18.24)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M271,107.83v-3a2,2,0,0,0-.28-.92l-1.45.83a1.7,1.7,0,0,1,.27.91v3Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M268.21,105.33a1.41,1.41,0,0,1,.52,1.09c0,.44-.23.66-.52.5a1.38,1.38,0,0,1-.52-1.09C267.69,105.39,267.91,105.17,268.21,105.33Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.36,104.27a1.34,1.34,0,0,1,.51,1.08c0,.44-.22.66-.51.5a1.36,1.36,0,0,1-.51-1.09C265.85,104.3,266.08,104.1,266.36,104.27Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.51,103.2a1.35,1.35,0,0,1,.53,1.1c0,.44-.23.66-.51.5a1.38,1.38,0,0,1-.52-1.09C264,103.25,264.23,103,264.51,103.2Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269.2,150l.11-.07.28-.16h0l.15-.08h0l.24-.14.49-.28.11-.06a.48.48,0,0,0,.16-.12.62.62,0,0,0,.12-.19,1.13,1.13,0,0,0,.11-.48V107.82l-1.45.84v40.59a1.4,1.4,0,0,1-.1.46.59.59,0,0,1-.17.24.12.12,0,0,1-.05.05Z",
    transform: "translate(-21.75 -18.24)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M244.65,98.14a.17.17,0,0,1,0-.12l.66-.57h0a.15.15,0,0,1,.05.06.17.17,0,0,1,0,.1v.58l-.05.06-.35.32.35.72s0,.08.05.12v.66a0,0,0,0,1-.05,0h0l0,0-.66-1.36a.47.47,0,0,1,0-.16Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M247,97.51a.22.22,0,0,1,.05-.08h.1l.24.15a.1.1,0,0,1,0,.06.14.14,0,0,1,0,.09v0l-1.15,3.49a.1.1,0,0,1,0,.07h-.1l-.23-.13a.13.13,0,0,1-.06-.07V101Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M248.78,100.86a.17.17,0,0,1-.05.12l-.65.58h0a.18.18,0,0,1,0-.07.14.14,0,0,1,0-.09v-.58a.18.18,0,0,1,0-.07l.34-.32-.34-.71a.61.61,0,0,1,0-.12V99a.06.06,0,0,1,0-.06h0a.08.08,0,0,1,0,0l.65,1.35a.48.48,0,0,1,.05.17Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M250.59,102.65a.16.16,0,0,1,.07.07v.61a.11.11,0,0,1,0,.08,0,0,0,0,1-.07,0l-.31-.17a.24.24,0,0,1-.06-.08.2.2,0,0,1,0-.11v-.47a.11.11,0,0,1,0-.08s.05,0,.06,0Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M251.63,103.24a.24.24,0,0,1,.06.08.2.2,0,0,1,0,.11v.5a.11.11,0,0,1,0,.08h-.06l-.31-.18a.23.23,0,0,1-.07-.07l0-.12v-.48a.12.12,0,0,1,0-.09,0,0,0,0,1,.07,0Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M252.66,103.84a.11.11,0,0,1,.06.07.24.24,0,0,1,0,.12v.5a.11.11,0,0,1,0,.08.06.06,0,0,1-.06,0l-.31-.18a.27.27,0,0,1-.07-.08.43.43,0,0,1,0-.11v-.51a.08.08,0,0,1,0-.08,0,0,0,0,1,.07,0Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M244.92,102.11,260,110.83a.7.7,0,0,1,.32.54c0,.2-.14.26-.32.16l-15.12-8.72a.73.73,0,0,1-.32-.54C244.6,102.08,244.75,102,244.92,102.11Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.77,113.31,264.89,122a.7.7,0,0,1,.32.54c0,.19-.14.27-.32.16L249.77,114a.73.73,0,0,1-.32-.54C249.45,113.27,249.6,113.21,249.77,113.31Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.77,118.9l7.24,4.18a.71.71,0,0,1,.33.54c0,.2-.15.27-.33.16l-7.23-4.18a.65.65,0,0,1-.32-.53C249.45,118.88,249.6,118.8,249.77,118.9Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M261.29,111.55l6,3.44a.71.71,0,0,1,.33.54c0,.19-.15.27-.33.16l-6-3.44a.65.65,0,0,1-.32-.53C261,111.53,261.11,111.45,261.29,111.55Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M244.92,132.9,260,141.63a.67.67,0,0,1,.32.53c0,.2-.14.27-.32.17l-15.12-8.73a.7.7,0,0,1-.32-.54C244.6,132.87,244.75,132.8,244.92,132.9Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M261.29,142.35l6,3.44a.71.71,0,0,1,.33.54c0,.19-.15.26-.33.16l-6-3.44a.68.68,0,0,1-.32-.54C261,142.32,261.11,142.25,261.29,142.35Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M261.29,134l6,3.44a.71.71,0,0,1,.33.54c0,.19-.15.27-.33.16l-6-3.44a.65.65,0,0,1-.32-.53C261,133.94,261.11,133.86,261.29,134Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M261.29,136.77l6,3.44a.68.68,0,0,1,.33.53c0,.2-.15.27-.33.17l-6-3.44a.68.68,0,0,1-.32-.54C261,136.73,261.11,136.67,261.29,136.77Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M256.15,131l3.39,1.95a.65.65,0,0,1,.32.53c0,.2-.14.27-.32.17l-3.39-2a.7.7,0,0,1-.32-.53C255.83,131,256,130.89,256.15,131Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M244.92,104.92l8.82,5.08a.7.7,0,0,1,.32.53c0,.2-.14.27-.32.17l-8.82-5.08a.73.73,0,0,1-.32-.54C244.6,104.88,244.75,104.81,244.92,104.92Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M244.92,104.92l8.82,5.08a.7.7,0,0,1,.32.53c0,.2-.14.27-.32.17l-8.82-5.08a.73.73,0,0,1-.32-.54C244.6,104.88,244.75,104.81,244.92,104.92Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M244.92,107.71l3,1.72a.7.7,0,0,1,.32.53c0,.2-.15.27-.32.17l-3-1.72a.73.73,0,0,1-.32-.54C244.6,107.68,244.75,107.6,244.92,107.71Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M244.92,107.71l3,1.72a.7.7,0,0,1,.32.53c0,.2-.15.27-.32.17l-3-1.72a.73.73,0,0,1-.32-.54C244.6,107.68,244.75,107.6,244.92,107.71Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M244.92,110.51l3,1.72a.7.7,0,0,1,.32.53c0,.19-.15.27-.32.16l-3-1.72a.7.7,0,0,1-.32-.53C244.6,110.48,244.75,110.4,244.92,110.51Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M244.92,110.51l3,1.72a.7.7,0,0,1,.32.53c0,.19-.15.27-.32.16l-3-1.72a.7.7,0,0,1-.32-.53C244.6,110.48,244.75,110.4,244.92,110.51Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M244.92,113.31l3,1.72a.7.7,0,0,1,.32.53c0,.2-.15.27-.32.17l-3-1.72a.73.73,0,0,1-.32-.54C244.6,113.27,244.75,113.21,244.92,113.31Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M244.92,113.31l3,1.72a.73.73,0,0,1,.32.54c0,.19-.15.26-.32.16l-3-1.72a.73.73,0,0,1-.32-.54C244.6,113.27,244.75,113.21,244.92,113.31Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M249.77,116.11l8.82,5.08a.68.68,0,0,1,.32.54c0,.19-.14.26-.32.16l-8.82-5.08a.73.73,0,0,1-.32-.54C249.45,116.08,249.6,116,249.77,116.11Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M259.84,121.91l3.84,2.23a.7.7,0,0,1,.32.53c0,.2-.15.27-.32.17l-3.84-2.23a.7.7,0,0,1-.32-.53C259.52,121.89,259.66,121.81,259.84,121.91Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M249.77,116.11l8.82,5.08a.68.68,0,0,1,.32.54c0,.19-.14.26-.32.16l-8.82-5.08a.73.73,0,0,1-.32-.54C249.45,116.08,249.6,116,249.77,116.11Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M259.84,121.91l3.84,2.23a.7.7,0,0,1,.32.53c0,.2-.15.27-.32.17l-3.84-2.23a.7.7,0,0,1-.32-.53C259.52,121.89,259.66,121.81,259.84,121.91Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M244.92,116.11l3,1.72a.7.7,0,0,1,.32.53c0,.19-.15.27-.32.17l-3-1.72a.73.73,0,0,1-.32-.54C244.6,116.08,244.75,116,244.92,116.11Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M244.92,116.11l3,1.72a.7.7,0,0,1,.32.53c0,.19-.15.27-.32.17l-3-1.72a.73.73,0,0,1-.32-.54C244.6,116.08,244.75,116,244.92,116.11Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M255,110.72l3.84,2.22a.73.73,0,0,1,.32.54c0,.19-.15.26-.32.16L255,111.42a.68.68,0,0,1-.32-.54C254.67,110.69,254.81,110.61,255,110.72Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M255,110.72l3.84,2.22a.73.73,0,0,1,.32.54c0,.19-.15.26-.32.16L255,111.42a.68.68,0,0,1-.32-.54C254.67,110.69,254.81,110.61,255,110.72Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M253.41,123.79l8.82,5.09a.73.73,0,0,1,.32.54c0,.19-.15.26-.32.16l-8.82-5.09a.65.65,0,0,1-.32-.53C253.09,123.79,253.23,123.7,253.41,123.79Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M258.5,129.53l8.83,5.11a.68.68,0,0,1,.33.53c0,.19-.15.27-.33.17l-8.81-5.09a.68.68,0,0,1-.32-.54C258.16,129.53,258.32,129.45,258.5,129.53Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M263.48,129.61l3.85,2.21a.7.7,0,0,1,.33.53c0,.2-.15.27-.33.17l-3.83-2.22a.66.66,0,0,1-.32-.54C263.15,129.58,263.32,129.53,263.48,129.61Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.48,140.7l3.83,2.22a.71.71,0,0,1,.33.54c0,.19-.15.26-.33.16l-3.83-2.22a.71.71,0,0,1-.33-.54C263.15,140.67,263.32,140.6,263.48,140.7Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M249.77,110.51l8.82,5.09a.65.65,0,0,1,.32.53c0,.19-.14.27-.32.17l-8.82-5.12a.7.7,0,0,1-.32-.53C249.45,110.48,249.6,110.4,249.77,110.51Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M249.77,110.51l8.82,5.09a.65.65,0,0,1,.32.53c0,.19-.14.27-.32.17l-8.82-5.12a.7.7,0,0,1-.32-.53C249.45,110.48,249.6,110.4,249.77,110.51Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M259.84,116.34l3.84,2.22a.73.73,0,0,1,.32.54c0,.19-.15.26-.32.16L259.84,117a.68.68,0,0,1-.32-.54C259.52,116.28,259.66,116.22,259.84,116.34Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M259.84,116.34l3.84,2.22a.73.73,0,0,1,.32.54c0,.19-.15.26-.32.16L259.84,117a.68.68,0,0,1-.32-.54C259.52,116.28,259.66,116.22,259.84,116.34Z",
    transform: "translate(-21.75 -18.24)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mouse--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M199.75,148.39l5.4,3.12a6,6,0,0,0,6-.31l8.91-6.51c1.59-1.15,1.5-2.87-.21-3.88l-2.7-1.57a7.36,7.36,0,0,0-6.27-.19l-11,6C198.09,145.9,198,147.41,199.75,148.39Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M220.17,141.86,214,146.68l-4.56,3.56a3.77,3.77,0,0,1-1.45.35,4,4,0,0,1-2.16-.45L201,147.35h0a3.45,3.45,0,0,1-1.08-4.75l.1-.14.14-.21a6.44,6.44,0,0,1,3.9-2.46l2.45-.49c4-.81,7.21-1.2,7.59-.94l6.06,3.51Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M216.73,144.56l.35-.28-5.44-3.13,4.76-1.48-.49-.28-4.75,1.48L207.91,139l-.61.11Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M210,150h0l4.34-3.13,5.84-4.22v-.69a.05.05,0,0,0,0,0h0c-.44-.15-3,.61-6,1.83l-2,.81a6.41,6.41,0,0,0-4.07,6v.1a3.86,3.86,0,0,0,1.45-.35Z",
    transform: "translate(-21.75 -18.24)"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M220.72,236.45c-5.95-6.14-9.44-31.12-3.64-36h29.53c5.8,4.87,2.29,29.85-3.64,36l-.16.17-.2.2a6.17,6.17,0,0,1-.54.48l-.15.12c-.14.11-.28.23-.44.34s-.51.35-.77.5c-4.9,2.87-12.83,2.87-17.73,0h0c-.25-.15-.51-.32-.77-.51s-.28-.21-.42-.32l-.17-.13a5.8,5.8,0,0,1-.52-.47l-.24-.23Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M220.72,236.45c-5.95-6.14-9.44-31.12-3.64-36h29.53c5.8,4.87,2.29,29.85-3.64,36l-.16.17-.2.2a6.17,6.17,0,0,1-.54.48l-.15.12c-.14.11-.28.23-.44.34s-.51.35-.77.5c-4.9,2.87-12.83,2.87-17.73,0h0c-.25-.15-.51-.32-.77-.51s-.28-.21-.42-.32l-.17-.13a5.8,5.8,0,0,1-.52-.47l-.24-.23Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M244.05,198.5c6.73,3.93,6.73,10.32,0,14.25s-17.67,3.93-24.4,0-6.74-10.32,0-14.25S237.31,194.57,244.05,198.5Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M244.05,198.5c6.73,3.93,6.73,10.32,0,14.25s-17.67,3.93-24.4,0-6.74-10.32,0-14.25S237.31,194.57,244.05,198.5Z",
    transform: "translate(-21.75 -18.24)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M240.81,200.39c4.94,2.87,4.94,7.58,0,10.47s-13,2.86-17.92,0-4.95-7.58,0-10.47S235.86,197.5,240.81,200.39Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.81,200.39c4.94,2.87,4.94,7.58,0,10.47s-13,2.86-17.92,0-4.95-7.58,0-10.47S235.86,197.5,240.81,200.39Z",
    transform: "translate(-21.75 -18.24)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.89,205.36c4.94-2.87,13-2.87,17.92,0a8.28,8.28,0,0,1,3,2.74,8.33,8.33,0,0,1-3,2.76c-4.95,2.86-13,2.86-17.92,0a8.36,8.36,0,0,1-3-2.76A8.31,8.31,0,0,1,222.89,205.36Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M229.43,192.75a8.2,8.2,0,0,1-.75-2.15,5.09,5.09,0,0,1,1.57-5c.57-.43,1.33-.76,1.58-1.45a2.36,2.36,0,0,0,0-1.18c-.27-1.54-.79-3.12-.36-4.62a5.16,5.16,0,0,1,2.86-3.07,15.55,15.55,0,0,1,4.17-1.09,6.76,6.76,0,0,0,2.21-.63c.82-.46,1.08-1.28,1.59-2a14.31,14.31,0,0,1,2-2.16,8,8,0,0,1,5.47-2.35c4.34.19,4.22,3.92,3,6.76s-1.59,3.75,1.14,6.7,2.72,6.6-.52,8.6-5.34,2.3-4.06,6.23c1.15,3.5,1.85,6.49-1.38,10.23a10.62,10.62,0,0,1-8.53,4,14.36,14.36,0,0,1-4.19-1c-1-.48-.32-1.25-.65-2.22l-2.15-6.26a45.09,45.09,0,0,0-1.72-4.94C230.32,194.36,229.83,193.57,229.43,192.75Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M229.43,192.75a8.2,8.2,0,0,1-.75-2.15,5.09,5.09,0,0,1,1.57-5c.57-.43,1.33-.76,1.58-1.45a2.36,2.36,0,0,0,0-1.18c-.27-1.54-.79-3.12-.36-4.62a5.16,5.16,0,0,1,2.86-3.07,15.55,15.55,0,0,1,4.17-1.09,6.76,6.76,0,0,0,2.21-.63c.82-.46,1.08-1.28,1.59-2a14.31,14.31,0,0,1,2-2.16,8,8,0,0,1,5.47-2.35c4.34.19,4.22,3.92,3,6.76s-1.59,3.75,1.14,6.7,2.72,6.6-.52,8.6-5.34,2.3-4.06,6.23c1.15,3.5,1.85,6.49-1.38,10.23a10.62,10.62,0,0,1-8.53,4,14.36,14.36,0,0,1-4.19-1c-1-.48-.32-1.25-.65-2.22l-2.15-6.26a45.09,45.09,0,0,0-1.72-4.94C230.32,194.36,229.83,193.57,229.43,192.75Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M235.33,208.64a.29.29,0,0,0,.21-.3c-.18-21.45,11.65-34.26,11.77-34.4a.34.34,0,0,0,0-.46.33.33,0,0,0-.45,0c-.13.13-12.12,13.11-11.94,34.84a.32.32,0,0,0,.31.32h.1Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M238.77,188.67l.07,0c3.85-2.43,10.71-4.23,10.78-4.25a.34.34,0,0,0,.23-.4.31.31,0,0,0-.38-.23h0c-.29.08-7,1.85-11,4.33a.31.31,0,0,0-.11.43h0A.31.31,0,0,0,238.77,188.67Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M240,185.71h0a.32.32,0,0,0,.18-.42,24.67,24.67,0,0,0-3.55-6,.31.31,0,0,0-.44,0h0a.33.33,0,0,0,0,.46,24.88,24.88,0,0,1,3.44,5.79.31.31,0,0,0,.4.19Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M232.32,210.94a18.15,18.15,0,0,1-9.42.34c-5.4-1.15-8.71-6.21-8.71-6.21s5.85-2.34,9.25-2.57a30.29,30.29,0,0,0-10.23.21s-3.13-1.14-2.54-6.44c0,0,3-2.17,9.74-1.32a21.7,21.7,0,0,0-9.35-3.14c-.47,0,.17-6.88.74-9.95s1.72-2.59,4.13-2.32,9.63,1.9,10.54,3.67,0,6.27,0,6.27a10.36,10.36,0,0,0,2-5.9,15.82,15.82,0,0,1,4.16,2.3,9.6,9.6,0,0,1,2.59,3.24,19.64,19.64,0,0,1-3.07,8.16,11,11,0,0,0,4.41-6.59,14.91,14.91,0,0,1,2.87,8.4A12.78,12.78,0,0,1,232.32,210.94Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M232.32,210.94a18.15,18.15,0,0,1-9.42.34c-5.4-1.15-8.71-6.21-8.71-6.21s5.85-2.34,9.25-2.57a30.29,30.29,0,0,0-10.23.21s-3.13-1.14-2.54-6.44c0,0,3-2.17,9.74-1.32a21.7,21.7,0,0,0-9.35-3.14c-.47,0,.17-6.88.74-9.95s1.72-2.59,4.13-2.32,9.63,1.9,10.54,3.67,0,6.27,0,6.27a10.36,10.36,0,0,0,2-5.9,15.82,15.82,0,0,1,4.16,2.3,9.6,9.6,0,0,1,2.59,3.24,19.64,19.64,0,0,1-3.07,8.16,11,11,0,0,0,4.41-6.59,14.91,14.91,0,0,1,2.87,8.4A12.78,12.78,0,0,1,232.32,210.94Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M233,210.47a.28.28,0,0,1-.19-.26C232,200,220.56,184,215.5,180.77a.31.31,0,0,1,.33-.53c5.16,3.26,16.79,19.49,17.62,29.92a.32.32,0,0,1-.28.33h0A.3.3,0,0,1,233,210.47Z",
    transform: "translate(-21.75 -18.24)"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-64-2",
    "data-name": "freepik--character--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M129.45,204.06c0-.12-1.84-6.77-1.84-6.77s.6.61,4.44-.4a22.53,22.53,0,0,0,4.18-1.75l1.1,4.86c1,1.87,4.42,1,8.13.57.63-.07,1.27-.18,1.91-.29h0c2-.1,4,1.1,1.94,2.81s-5.53,2.36-8.7,2.93C136.83,206.74,130.13,207.86,129.45,204.06Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M156.11,203.48a3.87,3.87,0,0,1,.28,2c-.07.74-1.9,3.25-5.16,4.8s-7.24,1.64-9.1,2.18-3.59,1.61-5.8,2.15-4.39.82-6.61-.64a5,5,0,0,1-.72-2.22C129.4,211.41,156.11,203.48,156.11,203.48Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137.91,200.66c1.42,1,4.37.3,7.55-.06,3-.34,6.38-1.4,8.42-.69s3.75,3.11,1,6.19A12,12,0,0,1,151,209c-3.44,1.23-6.5,1.32-8.7,1.87-2.87.7-4.44,2-7.08,2.29-3.44.4-5.61-.48-6.21-1.4s-1.14-8.31.33-8.15c0,0,.62,2.39,6.23.07C138.05,202.69,138,201.19,137.91,200.66Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M137.91,200.66c1.42,1,4.37.3,7.55-.06,3-.34,6.38-1.4,8.42-.69s3.75,3.11,1,6.19A12,12,0,0,1,151,209c-3.44,1.23-6.5,1.32-8.7,1.87-2.87.7-4.44,2-7.08,2.29-3.44.4-5.61-.48-6.21-1.4s-1.14-8.31.33-8.15c0,0,.62,2.39,6.23.07C138.05,202.69,138,201.19,137.91,200.66Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M147.43,204.63s-.32-3.12-2.63-3.94a1.2,1.2,0,0,0-1.27.16s2.14.31,2.87,4c0,0,.11.25.57.16C147.11,204.94,147.45,204.88,147.43,204.63Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M141.56,201.09s0-.11.54-.2a1,1,0,0,1,.64.06s1.72.75,2,4c0,0,0,.39-.53.5a.48.48,0,0,1-.61-.29,0,0,0,0,0,0,0S143.28,201.71,141.56,201.09Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M139.72,201.16s.09-.2.5-.2.63.2.63.2a5.93,5.93,0,0,1,1.23,4s.06.45-.57.5-.57-.47-.57-.47S140.72,201.71,139.72,201.16Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.08,158.88c2.81,8.45,10.26,37.52,10.26,37.52s-4.85,4.36-10.11,2.38l-12.54-36.21Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M148.74,213.46c-.57-.86-2.73-6.77-2.73-6.77s2.25,1.29,6.12.37a9.05,9.05,0,0,0,3.81-2.6l1.65,5.68c1,1.9,4.13,1.27,7.86.94.62-.06,1.26-.15,1.91-.24h0c2-.06,4,1.19,1.87,2.86s-5.59,2.23-8.78,2.72C156.69,217,150.89,216.67,148.74,213.46Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M177.65,213.28a4.24,4.24,0,0,1,.24,2.2c-.09.79-2.13,3.44-5.64,5s-7.81,1.57-9.84,2.1-3.89,1.63-6.27,2.16-4.74.76-7.07-.86a5.12,5.12,0,0,1-.72-2.41C148.73,221.09,177.65,213.28,177.65,213.28Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M158.19,209.71a5.23,5.23,0,0,0,.71.44,2.09,2.09,0,0,0,.78.16,10.72,10.72,0,0,0,1.88.05c1.57-.08,3.14-.32,4.71-.46,3.22-.28,6.88-1.33,9-.51s4.16,3.44,1.11,6.65a14.62,14.62,0,0,1-4.07,3.09c-3.61,1.51-7.35,1.23-9.75,1.76-3.09.68-4.81,2-7.67,2.26-3.69.34-6-.66-6.61-1.67-.35-.57,0-3.44-.43-5.7-.4-1.94-.29-3.26.41-3.17a3.52,3.52,0,0,0,.53.69,2.71,2.71,0,0,0,.82.65,6.87,6.87,0,0,0,1.39.46,8.65,8.65,0,0,0,2.58.36,1.29,1.29,0,0,0,.69-.23,1.42,1.42,0,0,0,.41-.87l.18-.86a1.11,1.11,0,0,1,.16-.44,1.09,1.09,0,0,1,.44-.35,3.89,3.89,0,0,0,1.41-1.07,3.33,3.33,0,0,0,.41-1.33.31.31,0,0,1,.09-.22c.1-.08.26,0,.37.06Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M158.19,209.71a5.23,5.23,0,0,0,.71.44,2.09,2.09,0,0,0,.78.16,10.72,10.72,0,0,0,1.88.05c1.57-.08,3.14-.32,4.71-.46,3.22-.28,6.88-1.33,9-.51s4.16,3.44,1.11,6.65a14.62,14.62,0,0,1-4.07,3.09c-3.61,1.51-7.35,1.23-9.75,1.76-3.09.68-4.81,2-7.67,2.26-3.69.34-6-.66-6.61-1.67-.35-.57,0-3.44-.43-5.7-.4-1.94-.29-3.26.41-3.17a3.52,3.52,0,0,0,.53.69,2.71,2.71,0,0,0,.82.65,6.87,6.87,0,0,0,1.39.46,8.65,8.65,0,0,0,2.58.36,1.29,1.29,0,0,0,.69-.23,1.42,1.42,0,0,0,.41-.87l.18-.86a1.11,1.11,0,0,1,.16-.44,1.09,1.09,0,0,1,.44-.35,3.89,3.89,0,0,0,1.41-1.07,3.33,3.33,0,0,0,.41-1.33.31.31,0,0,1,.09-.22c.1-.08.26,0,.37.06Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M168.27,214.28s-.27-3.36-2.72-4.31a1.31,1.31,0,0,0-1.37.15s2.29.39,2.95,4.34c0,0,.11.26.62.18C167.91,214.62,168.28,214.56,168.27,214.28Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M162.06,210.33s0-.12.58-.21a1,1,0,0,1,.67.09s1.83.85,2.09,4.36c0,0,0,.42-.57.52a.52.52,0,0,1-.65-.32v0S163.89,211,162.06,210.33Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M160.08,210.36s.11-.2.55-.19.66.23.66.23a6.36,6.36,0,0,1,1.23,4.3s0,.5-.65.54-.57-.53-.57-.53S161.15,211,160.08,210.36Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.85,168.85c2.21,6.81,7.86,26.18,10.44,36.12,0,0-4.63,4.17-10.6,3.8L132.3,171.48l5.74-3.55Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.49,262a.93.93,0,0,0,.93-.94h0V201.08a.93.93,0,0,0-.93-.93.94.94,0,0,0-.94.93v60A.94.94,0,0,0,99.49,262Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M62.39,240.17a.92.92,0,0,0,.87-.57l18.38-46.54a.93.93,0,1,0-1.66-.83s0,.1-.06.15l-18.4,46.49a.93.93,0,0,0,.52,1.21A.73.73,0,0,0,62.39,240.17Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.6,234.56a.9.9,0,0,0,.67-.29l34.22-36.2,34.15,36a.93.93,0,0,0,1.35-1.28l-34.82-36.77a1,1,0,0,0-.68-.29h0a1,1,0,0,0-.68.29L63.92,233a1,1,0,0,0,0,1.33.93.93,0,0,0,.64.25Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.59,240.17a1,1,0,0,0,.34-.06.94.94,0,0,0,.52-1.21l-18.38-46.54a.94.94,0,0,0-1.82.44.72.72,0,0,0,.1.24l18.39,46.54A.92.92,0,0,0,136.59,240.17Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137,180.52c.67-3.76-2.39-6.7-8.15-10.59a136.79,136.79,0,0,0-16.7-9.39c-4.83-2.21-9.75-2-15.94,1.15-8.6,4.41-34.39,20.07-34.39,20.07s38.59,21.78,46,20.81,26-13,27.46-17.3S137,180.52,137,180.52Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M137,180.52c.67-3.76-2.39-6.7-8.15-10.59a136.79,136.79,0,0,0-16.7-9.39c-4.83-2.21-9.75-2-15.94,1.15-8.6,4.41-34.39,20.07-34.39,20.07s38.59,21.78,46,20.81,26-13,27.46-17.3S137,180.52,137,180.52Z",
    transform: "translate(-21.75 -18.24)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104.14,198c5.54,5,11.33.7,20.49-5.25C135,186,137,180.52,137,180.52s0,4.12-.77,6.06-2.45,4.12-9.92,9.28-12.9,7.73-17.92,8.69l-4-.55",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124.63,192.75C135,186,137,180.52,137,180.52s0,4.12-.77,6.06-2.45,4.12-9.92,9.28-12.9,7.73-17.92,8.69l-4-.55-.31-6C109.68,203,115.47,198.7,124.63,192.75Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63.81,232.85,61,239.39a1.16,1.16,0,0,0,0,.18v.12a.8.8,0,0,0,.36.43,1.71,1.71,0,0,0,1.54.08.62.62,0,0,0,.31-.31h0v-.08l2.64-6.14Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M135.32,233.12l2.45,6.42v.28a.76.76,0,0,1-.37.4,1.61,1.61,0,0,1-1.48,0,.65.65,0,0,1-.29-.3h0v-.09l-2.25-6Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.41,256.4v5.31a.57.57,0,0,0,.32.43,1.63,1.63,0,0,0,1.52,0,.52.52,0,0,0,.31-.43V256.4A2.28,2.28,0,0,0,98.41,256.4Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.31,158c2.19,2.56,22.2-3.19,27.52-3.91,8.54-1.15,15.48-2,18.4-1.1s4.13,2.39,5,5.86l1.59,6.19s-14.2,5.44-25.4,6.76S77.31,158,77.31,158Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.56,161.79c-2.22,8.45-4.21,18.27.92,23.65,3.44,3.62,20.82,13,32,9.33,11-3.65,33.88-20.64,36.18-22.32s4.37-2.87,4.15-3.6c-3.08-10.23-7.58-11-15.93-9.17-10.22,2.24-32.63,11.39-32.63,11.39Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "102.56 89.23 94.85 97.94 82.41 92.03 91.11 80 102.56 89.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M133.86,90.92s3.16,4.55,2.82,5-2.57.92-2.57.92Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M133.84,93.93a3.77,3.77,0,1,1,3.77-3.77A3.77,3.77,0,0,1,133.84,93.93Zm0-6.85a3.08,3.08,0,1,0,3.08,3.08h0a3.1,3.1,0,0,0-3.08-3.06Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M125.11,78.32c6.2,1.15,8,3.83,8.85,13.62.83,10.22-.14,13.46-1.45,14.87-.89,1-5.93,1.24-8.49.57-3.2-.81-10.46-3.19-14-8.27-4.1-6-5.34-14.15-1.14-17.61C114.77,76.64,122.59,77.85,125.11,78.32Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M124.31,107.47c2.66.57,6.72.23,7.93-.46a9.22,9.22,0,0,1-4.49-.16,14.67,14.67,0,0,1-4.11-1.81Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M135.1,82.33h0a14.19,14.19,0,0,1-5.91,2,12.29,12.29,0,0,1-.88,4.88c-.36,1.1-1.65,4.55-3,2.65-1-1.36-1.93-2.61-3.88-2.29-3.2.57-3.53,4.65-1.45,7.09s3.94,1.45,3.94,1.45.29,4.41-2,7.52a10.47,10.47,0,0,1-8.35.53c-3.07-1-7.51-4.89-9.14-7.92-4.5-8.32-4.52-16.3.93-18.75.51-4,3.6-5.85,7.15-6.75,4.92-1.25,10,1.84,14.8-.2,1-.43,1.92-1,3-1.41a2,2,0,0,1,1.77,0,2.17,2.17,0,0,1,.76,1.35,3.86,3.86,0,0,1-.19,2.87,8.51,8.51,0,0,1,2.24-.83A2.82,2.82,0,0,1,137,75a2.9,2.9,0,0,1,.9,2A6.14,6.14,0,0,1,135.1,82.33Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M105.2,80.87l-3.74-2.1a2.14,2.14,0,0,1,3.83,1.92A1.51,1.51,0,0,1,105.2,80.87Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 125.14,
    y: 90.48,
    width: 12.19,
    height: 0.59,
    transform: "translate(-36.17 7.38) rotate(-10.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M150.3,112.56c-.32-.54-1-.65-1.63-.86-1.1-.38-2-1.26-3-1.72a6,6,0,0,0-3.82-.25,9.49,9.49,0,0,0-1.28.4,16.34,16.34,0,0,0-2.29,1.15c-3,1.79-5.32,5.86-8.31,7.72-1.11.7-2.15,1.33-3.17,2l7.15,6.33a44.08,44.08,0,0,1,3.52-2.68c1.75-1,3.52-1.06,5.49-1.35a27.46,27.46,0,0,0,4-1,1.74,1.74,0,0,0,1.18-.78,1.17,1.17,0,0,0-.76-1.46,9.83,9.83,0,0,0-2.08-.29c-.52-.08-1.9.22-2.2-.29-.16-.28,0-.61.23-.86,1.24-1.54,2.81-3.19,4.79-3.65a4.24,4.24,0,0,0,1.72-.7A1.37,1.37,0,0,0,150.3,112.56Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M107.65,105.45c-7.57-4.13-14.47-1.48-17,3.83-2.25,4.81-7,23.42-7,23.42C86,137,107.65,105.45,107.65,105.45Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.52,106.94l1.14-1.5c-8.55-4.06-16.2,1.28-22.93,11.77-7.27,11.3-11.08,27.52-11.11,44.66,0,0,1.45,7.7,11.17,11.55,10.32,4.09,24.71,2.36,29.2-8.34,0,0,.1-10.68,3.34-16,2.1-3.4,7-11,10.65-16.39,3.18-4.73,5.65-15.48-1-19.41a57.06,57.06,0,0,0-5.4-2.75C115.54,112.58,105.74,109.34,106.52,106.94Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M106.54,107l1.11-1.54c-8.55-4.06-16.2,1.28-22.93,11.77-7.27,11.3-11.08,27.52-11.12,44.66,0,0,1.45,7.7,11.18,11.55,10.32,4.09,24.71,2.36,29.2-8.34,0,0,.09-10.68,3.34-16,2.1-3.4,7-11,10.65-16.39,3.18-4.73,5.65-15.48-1-19.41a55.71,55.71,0,0,0-5.39-2.75C115.54,112.58,105.76,109.38,106.54,107Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M130.72,125.89a17.41,17.41,0,0,0,.26-6.23h0a33.18,33.18,0,0,1-6.46,9.87c-3.48,3.66-7.77,6.52-11,10.4-3.44,4.12-5.87,9.1-8.74,13.6-1.15,1.8-2.72,5.28-4.85,5.42-2.6.17-5.09-3-6.51-5.19-2.29-3.48-4.2-7.85-7-10.89-2.46-2.68-6.27-6.11-9.61-4.55h0c-.26.88-.49,1.78-.71,2.69s-.43,1.85-.63,2.77v.11c-.19.93-.37,1.86-.53,2.8v.15c-.16.92-.31,1.85-.43,2.78a90.08,90.08,0,0,0-.86,12.28s1.45,7.7,11.18,11.54c10.32,4.09,24.71,2.36,29.2-8.34,0,0,.09-10.68,3.34-15.94.32-.53.73-1.15,1.14-1.88h0l.08-.12c.37-.57.77-1.22,1.21-1.9,0,0,0-.08.08-.12v0c.93-1.45,2-3.05,3-4.71l.49-.75c1-1.59,2.1-3.21,3.11-4.72h0c.34-.52.67-1,1-1.5.14-.21.28-.42.41-.63h0c.12-.16.23-.35.34-.53l.11-.17.24-.43.1-.19.26-.5.06-.14c.11-.22.21-.45.32-.68v-.07l.27-.66a1,1,0,0,1,0-.16l.24-.63v-.13c.14-.4.26-.81.38-1.22h0c.11-.42.21-.84.31-1.27v0Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M170.38,136.29a16.18,16.18,0,0,1-1.77,1.84c-2.62,2.36-5.67,3.51-9.23,5.81-2.87,1.86-7.3,4.59-11,6.91a56.16,56.16,0,0,1-12,5.55c-3.44,1-5.4,1.06-7.45-4.49-1-2.72-1.8-5.52-2.67-8.29q-1.93-6.18-3.81-12.39c-1.87-6.2-4.59-11.37,5.73-17.08,4.49,2.57,6.2,3.61,7.61,9,1.69,6.43,4.42,19.14,4.42,19.14a91.56,91.56,0,0,0,10.65-4.54c1.31-.65,2.92-1.1,3.86-2.27a17.56,17.56,0,0,0,1.64-2.55c.44-.8.75-1.66,1.24-2.41a20.71,20.71,0,0,1,3.39-3.73,1.38,1.38,0,0,1,.82-.49,1,1,0,0,1,.83.5c.38.67,0,1.32-.17,2s-.44,1.55-.66,2.3a20.31,20.31,0,0,0,6.57-6.14,3.3,3.3,0,0,1,.52-.65,1,1,0,0,1,.77-.28c.69.08,1.37,1.19,1.4,1.83a11.41,11.41,0,0,0,.05,1.94c.16.58.58,1.09.75,1.68a9.05,9.05,0,0,1,.39,1.86,6.32,6.32,0,0,1-1,3.89A9.18,9.18,0,0,1,170.38,136.29Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.49,113.68c3.93,1.58,6.76,3.38,8.55,9.38s3.74,15.64,3.74,15.64,0,2-4.74,4.83a11.71,11.71,0,0,1-9.23,1.24l-3.6-11.58S115.82,117.68,127.49,113.68Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104.45,204c-3.16-.16-5.63-2.47-13.12-5.6-13.86-5.77-24.24-10.4-28.21-17.64s-6.75-28.2-5.76-37.27a12,12,0,0,1,.67-3l-1-.14,2.52-2.15h0c2.59-2.11,6.8-.23,10,1.5,9.07,4.93,16.16,9.74,21.78,27,4.22,13,7,24.9,12.82,31.25",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58,140.49l-1-.14,2.52-2.15h0c2.59-2.11,6.8-.23,10,1.5,9.07,4.93,16.16,9.74,21.78,27,4.22,13,7,24.9,12.82,31.25l.31,6c-3.16-.16-5.63-2.48-13.13-5.6-13.87-5.77-24.25-10.4-28.22-17.64s-6.75-28.2-5.76-37.27A12,12,0,0,1,58,140.49Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.93,141.93c9.07,4.93,16.16,9.75,21.79,27s8.67,32.61,19.72,35.57c0,0-5,2-20.3-4.49-4.88-2.06-10.79-5.81-14.67-8-7.61-4.27-12.22-7.77-12.95-9.08-4-7.22-6.76-28.2-5.77-37.27S62.39,139.46,66.93,141.93Z",
    transform: "translate(-21.75 -18.24)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-64-2",
    "data-name": "freepik--speech-bubble--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117.9,65.14l-2.49-4.71,2-5.82V51.05l-6.16,3.56v3.56l2.65,4.59a.35.35,0,0,0,.18.16h0Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117.9,65.14l-2.49-4.71,2-5.82V51.05l-6.16,3.56v3.56l2.65,4.59a.35.35,0,0,0,.18.16h0Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M132.61,22.75a4.09,4.09,0,0,0-1.85-3.2l-1.51-.87a4.07,4.07,0,0,0-3.69,0L102.48,32a4.08,4.08,0,0,0-1.84,3.21v25.4a4.08,4.08,0,0,0,1.84,3.2l1.51.87a4.09,4.09,0,0,0,3.7,0l7.42-4.29L117.76,65a.39.39,0,0,0,.71-.07l2.8-8.07,9.5-5.51a4.09,4.09,0,0,0,1.84-3.21Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.64,60.64a4.08,4.08,0,0,0,1.84,3.2l1.51.87a4.11,4.11,0,0,0,3.38.15c-.87.33-1.53-.16-1.53-1.22V38.24a3.78,3.78,0,0,1,.54-1.82l-5.21-3a3.81,3.81,0,0,0-.53,1.83Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M132.56,22.22c-.21-.78-.93-1-1.78-.54L107.69,35a3.52,3.52,0,0,0-1.3,1.38l-5.21-3a3.8,3.8,0,0,1,1.3-1.37l23.09-13.36a4.09,4.09,0,0,1,3.7,0l1.51.87A4.06,4.06,0,0,1,132.56,22.22Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M109.23,48.21a1.39,1.39,0,0,1,.1-.53,2.62,2.62,0,0,1,.27-.49l5-8.11a.39.39,0,0,1,.08-.1l.06,0a.13.13,0,0,1,.18,0,.33.33,0,0,1,.08.25v3.13a1.35,1.35,0,0,1-.15.65,3.7,3.7,0,0,1-.25.43l-2.59,4,2.59,1.19a1.15,1.15,0,0,1,.25.12c.1.06.15.22.15.47v2.23a.76.76,0,0,1-.08.33.52.52,0,0,1-.18.23h-.14l-5-2.29a.58.58,0,0,1-.27-.19.66.66,0,0,1-.1-.41Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M120.17,35.68a5.27,5.27,0,0,1,.19-.51.93.93,0,0,1,.37-.39l1.68-1a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.25.61.61,0,0,1,0,.19l-4.24,18.08a2.22,2.22,0,0,1-.18.49.8.8,0,0,1-.37.4l-1.64,1a.18.18,0,0,1-.2,0,.34.34,0,0,1-.08-.26.54.54,0,0,1,0-.18Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M129.4,38.6a1.6,1.6,0,0,1-.09.53,3.84,3.84,0,0,1-.27.49l-5,8.12-.08.09-.06.05a.14.14,0,0,1-.19,0,.32.32,0,0,1-.07-.25V44.49a1.3,1.3,0,0,1,.14-.64c.1-.17.18-.31.26-.42L126.2,40,124,39.2a1.26,1.26,0,0,1-.26-.13c-.1-.07-.14-.23-.14-.49V35.45a.72.72,0,0,1,.07-.33.6.6,0,0,1,.19-.23H124l5,2.3a.49.49,0,0,1,.36.57Z",
    transform: "translate(-21.75 -18.24)"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-64-2",
    "data-name": "freepik----inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-64-3",
    "data-name": "freepik--speech-bubble--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62.38,19.57l-30.9,17.8a1.69,1.69,0,0,0-.76,1.32V55.94a1.66,1.66,0,0,0,.76,1.35L34.53,59a1.74,1.74,0,0,0,1.54,0L67,41.24a1.71,1.71,0,0,0,.76-1.33V22.62A1.65,1.65,0,0,0,67,21.3l-3-1.72A1.74,1.74,0,0,0,62.38,19.57Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.72,22.48c0-.39-.37-.53-.75-.31L36.08,40a1.53,1.53,0,0,0-.55.58L31,37.91a1.5,1.5,0,0,1,.52-.57l30.9-17.77a1.72,1.72,0,0,1,1.53,0L67,21.29A1.7,1.7,0,0,1,67.72,22.48Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67,22.18,36.07,40a1.71,1.71,0,0,0-.76,1.33V58.55c0,.48.34.69.76.44L67,41.22a1.71,1.71,0,0,0,.76-1.33V22.62C67.73,22.13,67.39,21.93,67,22.18Z",
    transform: "translate(-21.75 -18.24)"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-64-3",
    "data-name": "freepik----inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-64-4",
    "data-name": "freepik--speech-bubble--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-64-2",
    "data-name": "freepik--speach-bubble--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62.38,55.41,31.48,73.18a1.71,1.71,0,0,0-.76,1.33V91.76a1.67,1.67,0,0,0,.76,1.32l3.05,1.72a1.74,1.74,0,0,0,1.54,0L67,77a1.69,1.69,0,0,0,.76-1.33V58.44A1.67,1.67,0,0,0,67,57.12l-3-1.72A1.74,1.74,0,0,0,62.38,55.41Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.72,58.32c0-.39-.37-.52-.75-.31L36.08,75.79a1.58,1.58,0,0,0-.55.57L31,73.73a1.45,1.45,0,0,1,.52-.55l30.9-17.77a1.72,1.72,0,0,1,1.53,0L67,57.13A1.68,1.68,0,0,1,67.72,58.32Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67,58,36.07,75.79a1.71,1.71,0,0,0-.76,1.33V94.38c0,.49.34.69.76.45L67,77.05a1.69,1.69,0,0,0,.76-1.33V58.44C67.73,58,67.39,57.77,67,58Z",
    transform: "translate(-21.75 -18.24)"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-64-4",
    "data-name": "freepik----inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-64-5",
    "data-name": "freepik--speech-bubble--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-64-3",
    "data-name": "freepik--speach-bubble--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62.38,91.25l-30.9,17.8a1.67,1.67,0,0,0-.76,1.32v17.25a1.65,1.65,0,0,0,.76,1.32l3.05,1.72a1.74,1.74,0,0,0,1.54,0L67,112.86a1.71,1.71,0,0,0,.76-1.33V94.3A1.68,1.68,0,0,0,67,93l-3-1.72A1.74,1.74,0,0,0,62.38,91.25Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.72,94.16c0-.39-.37-.53-.75-.31L36.08,111.62a1.53,1.53,0,0,0-.55.58L31,109.57a1.46,1.46,0,0,1,.52-.58l30.9-17.77a1.72,1.72,0,0,1,1.53,0L67,92.94A1.67,1.67,0,0,1,67.72,94.16Z",
    transform: "translate(-21.75 -18.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67,93.85l-30.9,17.77a1.71,1.71,0,0,0-.76,1.33v17.24c0,.5.34.69.76.45L67,112.84a1.69,1.69,0,0,0,.76-1.33V94.3C67.73,93.81,67.39,93.61,67,93.85Z",
    transform: "translate(-21.75 -18.24)"
  }))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-28",
    transform: "matrix(0.76, -0.42, 0.03, 1, 22.12, 29.57)"
  }, "RE", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 9.81,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 14.8,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 19.35,
    y: 0
  }, "T"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-28",
    transform: "matrix(0.76, -0.42, 0.03, 1, 25.73, 98.8)"
  }, "SQ", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 10.39,
    y: 0
  }, "L"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-33",
    transform: "matrix(0.76, -0.42, 0.03, 1, 16.93, 67.49)"
  }, "ANGU", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 20.3,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.63,
    y: 0
  }, "AR"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopment);
export default __webpack_public_path__ + "static/media/development.5a480ff6f3999fb2a95cbe9ceb352d7d.svg";
export { ForwardRef as ReactComponent };